import { useEffect, useState } from 'react';

export default function useRewardful() {
  const [isRewardfulLoaded, setIsRewardfulLoaded] = useState(false);
  const [coupon, setCoupon] = useState(null);
  const [referral, setReferral] = useState(null);

  useEffect(() => {
    let retries = 0;
    // Function to check if Rewardful is loaded
    const checkRewardfulLoaded = () => {
      if (window.Rewardful) {
        setIsRewardfulLoaded(true);
      } else {
        // Retry after a delay if Rewardful is not available yet
        const timeout = setTimeout(checkRewardfulLoaded, 1000);
        retries++;

        if (retries > 10) {
          setIsRewardfulLoaded(false);
          clearTimeout(timeout);
        }
      }
    };

    // Start checking if Rewardful is loaded
    checkRewardfulLoaded();
  }, []);

  useEffect(() => {
    if (isRewardfulLoaded && window.Rewardful) {
      setCoupon(window.Rewardful.coupon);
      setReferral(window.Rewardful.referral);
    }
  }, [isRewardfulLoaded]);

  return {
    coupon,
    referral,
  };
}
